export default function(isBackEnd) {
  if (isBackEnd)
  {
    //return;
  }

  $('.video_box--html5')
      .each((index, component) => {
        const $component = $(component);
        const mp4Url = $component.attr('data-url-mp4');

        $component.on('hide.bs.modal', () => {
          $component.find('.modal-body video').remove();
        });

        $component.on('show.bs.modal', () => {
          $component.find('.modal-body').append(
              `<video width="100%" autoplay controls>` +
              /**/`<source src="${mp4Url}" type="video/mp4">` +
              `</video>`);
        });
      });

  $('.video_box--vimeo')
      .each((index, component) => {
        const $component = $(component);
        const url = $component.attr('data-url');

        $component.on('hide.bs.modal', () => {
          $component.find('iframe').attr('src', '');
        });

        $component.on('show.bs.modal', () => {
          $component.find('iframe').attr('src', url);
        });
      });
}
